import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Sealing_the_house_envelope() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>      איטום מעטפת הבית  </h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Sealing_the_house_envelope">     איטום מעטפת הבית </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">
    <div className="red-banner">
איטום מעטפת הבית החיצונית קירות חיצוניים ע"י סנפלינג, במות הרמה ופיגומים    </div>

    <div className="content-row2">


      <div className="text-box">
       <p>  
במדינת ישראל כ-30% מבתי האב הם מבנים בני למעלה מ-30 שנים במבנים אלו קיימים ליקויים רבים במעטפת החיצונית של המבנה אשר דורשים טיפול באופן מקומי או באופן מקיף לכל המבנה את איטום הקירות החיצוניים מבצעים באמצעות סנפלינג / במות הרמה / מנוף סל / פיגומים.        </p>
\
  <h2 className="info-title">  * יש להקפיד ולוודא שלקבלן המבצע יש את האישורים ההסמכות והביטוחים לו ולעובדיו לבצע את העבודות הנ"ל אחרת כל נזק או תקלה היא באחריות מזמין העבודה! 





</h2>






    <p>  
אנו באיטומים בגבהים מוסמכים ומאושרים לבצע את כל העבודות הנ"ל ע"י משרד העבודה וקיים כיסוי ביטוחי לכל אתר בו אנו עובדים ע"י הכשרה חברה לביטוח.


</p>





      </div>

    </div>





    <ContactSection2/>
<div className="links2">


  <Link to="/Sealing_tiled_roofs_using_an_innovative_method" className="link-right" >      איטום גגות מרוצפים בשיטה חדשנית </Link>
  <Link to="/Solving_and_repairing_malfunctions_in_existing_sealing_systems" className="link-left" >   פתרון ותיקון תקלות במערכות איטום קיימות
    </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


